import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_close",
  "use": "svg_close-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"svg_close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.96 2.545a1 1 0 0 1 1.413-1.414l5.293 5.293L12.96 1.13a1 1 0 1 1 1.414 1.414L9.08 7.838l5.293 5.293a1 1 0 0 1-1.414 1.414L7.666 9.252l-5.293 5.293A1 1 0 0 1 .96 13.131l5.293-5.293L.959 2.545Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol